<template>
	<b-row>
		<b-col>
			<b-row>
				<b-col cols="12 mb-3">
					<b>{{data.shifttask}}</b>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12 mb-3">
					<i class="mh-icon-watch mr-1"></i>
					{{moment(data.servicedate, "D/MM/YYYY hh:mm:ss A").format("hh:mm A")}}
					-
					{{moment(data.enddate, "D/MM/YYYY hh:mm:ss A").format("hh:mm A")}}
					<span class="grey">({{this.data.totalhours}}h)</span>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12 mb-3">
					<icon name="regular/address-card" class="mr-1"></icon>
					{{data.clientfullname}}
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12 mb-3">
					<div class="mh-profile-label m-0">
						<div class="mh-img-wrap">
							<ProfileImage :imageUrl="customerProfilePicture" />
							<span class="mh-user-online"></span>
						</div>
						<span class="mh-title">{{customer.name}}</span>
					</div>
				</b-col>
			</b-row>
			<b-row v-if="data.shiftnotes != ''">
				<b-col cols="12 mb-3">
					<div class="blurb">
						{{data.shiftnotes}}
					</div>
				</b-col>
			</b-row>
			<b-row v-if="profile.isadmin && notifiedStaffs.length > 0">
				<b-col cols="12 mb-3">
					<div class="blurb">
						<b>Notified Staff:</b>
						<br />
						<b-form-row v-for="(notifiedStaff, i) in notifiedStaffs" :key="i">
							<b-col>
								{{notifiedStaff.name}}
							</b-col>
						</b-form-row>
					</div>
				</b-col>
			</b-row>
			<b-form-row class="mh-action-nav">
				<b-col v-if="canCancelShift">
					<b-button class="btn-default m-0" @click="cancelShift(data)" block>Cancel</b-button>
				</b-col>
				<b-col v-if="canEditShift">
					<b-button class="btn-default btn-green m-0" @click="editShift(data)" block>Edit</b-button>
				</b-col>
				<b-col v-if="canEditShift">
					<b-button class="btn-default btn-red m-0" @click="deleteShift(data)" block>Delete</b-button>
				</b-col>
			</b-form-row>
			<b-form-row v-if="profile.isadmin && !isShiftAssigned && notifiedStaffs.length < 1" class="mh-action-nav mt-2">
				<b-col class="text-center">
					<button class="btn btn-yellow" @click="isShowingPublishShiftAvailability = true">Publish Shift Availability</button>
				</b-col>
			</b-form-row>
		</b-col>

		<b-modal ref="forms" :visible="isShowingPublishShiftAvailability"
				 @hide="isShowingPublishShiftAvailability = false"
				 size="xl"
				 modal-class="shift-form publish-shift-availability"
				 body-class="mh-off-middle"
				 hide-footer>
			<template slot="modal-title">
				<h5 class="modal-title">Publish Shift Availability</h5>
			</template>
			<template slot="default">
				<PublishShiftAvailability :serviceScheduleIds="data.servicescheduleid" @close-form="isShowingPublishShiftAvailability = false" />
			</template>
		</b-modal>
	</b-row>
</template>

<script>
	import ProfileImage from "./ProfileImage"
	import PublishShiftAvailability from "./PublishShiftAvailability"

    export default {
		name: 'ShiftDetails',
		components: {
			ProfileImage,
			PublishShiftAvailability
		},
		props: {
			data: null
		},
		data() {
			return {
				isShowingPublishShiftAvailability: false
			}
		},
		mounted() {
			if (this.profile.isadmin && this.data.servicescheduleid)
				this.$store.dispatch("Shifts/getNotifiedStaffDetails", this.data.servicescheduleid)
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			customers: function () {
				return this.$store.state.Customers.customers
			},
			customer: function () {
				return this.customers.filter(x => x.id == this.data.clientid)[0]
			},
			customerProfilePicture: function () {
				return this.customer.profilepic
			},
			notifiedStaffs: function () {
				return this.$store.state.Shifts.notifiedStaffs
			},
			statusValues: function () {
				return this.$store.state.Shifts.statusValues
			},
			canCancelShift: function () {
				return this.data.allStatuses == this.statusValues.pending
					|| this.data.allStatuses == this.statusValues.unconfirmed
					|| this.data.allStatuses == this.statusValues.scheduled
					|| this.data.allStatuses == this.statusValues.unpublished
			},
			canEditShift: function () {
				return this.data.allStatuses == this.statusValues.pending
					|| this.data.allStatuses == this.statusValues.unconfirmed
					|| this.data.allStatuses == this.statusValues.scheduled
					|| this.data.allStatuses == this.statusValues.unpublished
					|| this.data.allStatuses == this.statusValues.error
			},
			canDeleteShift: function () {
				return (this.data.allStatuses == this.statusValues.pending
					|| this.data.allStatuses == this.statusValues.unconfirmed
					|| this.data.allStatuses == this.statusValues.scheduled
					|| this.data.allStatuses == this.statusValues.unpublished
					|| this.data.allStatuses == this.statusValues.error)
					&& this.data.timesheetapproved !== "True"
			},
			isShiftAssigned: function () {
				return this.data != null && this.data.employeeid != "0"
			}
		},
		methods: {
			cancelShift: function (data) {
				this.$emit("cancel-shift", data)
			},
			editShift: function (data) {
				this.$emit("edit-shift", data)
			},
			deleteShift: function (data) {
				this.$emit("delete-shift", data)
			}
		}
    }
</script>

<style scoped>
</style>